import React from 'react';
import { SEOHead } from '../components/SEOHead';
import { Link } from 'react-router-dom';
import { Badge } from '../components/ui/badge';
import { COMPANY_INFO } from '../lib/utils';

export default function PolitiqueConfidentialitePage() {
  return (
    <div>
      <SEOHead title="Politique de confidentialité" description="Politique de confidentialité et protection des données personnelles (RGPD) du site Ptitservices.com." path="/politique-confidentialite" />
      <section className="bg-[linear-gradient(135deg,hsla(195,20%,97%,1)_0%,hsla(182,40%,94%,1)_55%,hsla(195,20%,97%,1)_100%)] py-12 sm:py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <div className="flex items-center gap-2 text-sm text-muted-foreground mb-6">
            <Link to="/" className="hover:text-foreground">Accueil</Link>
            <span>/</span>
            <span className="text-foreground font-medium">Politique de confidentialité</span>
          </div>
          <Badge className="mb-3 bg-[hsl(var(--brand-mint))] text-[hsl(var(--brand-ink))] hover:bg-[hsl(var(--brand-mint))]">RGPD</Badge>
          <h1 className="font-['Space_Grotesk'] text-3xl sm:text-4xl font-semibold tracking-tight">Politique de confidentialité</h1>
        </div>
      </section>

      <section className="py-12 sm:py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <div className="space-y-8">
            <div>
              <h2 className="font-['Space_Grotesk'] text-xl font-semibold mb-3">1. Responsable du traitement</h2>
              <div className="text-sm text-muted-foreground leading-relaxed space-y-2">
                <p>Le responsable du traitement des données personnelles collectées sur le site ptitservices.com est :</p>
                <p><strong>Ptitservices.com</strong><br />{COMPANY_INFO.address}, {COMPANY_INFO.city}<br />Email : {COMPANY_INFO.email}<br />Téléphone : {COMPANY_INFO.phone}</p>
              </div>
            </div>

            <div>
              <h2 className="font-['Space_Grotesk'] text-xl font-semibold mb-3">2. Données collectées</h2>
              <div className="text-sm text-muted-foreground leading-relaxed space-y-2">
                <p>Nous collectons les données personnelles suivantes lorsque vous utilisez nos formulaires :</p>
                <ul className="list-disc pl-5 space-y-1">
                  <li><strong>Formulaire de devis :</strong> nom, téléphone, email, ville, code postal, services souhaités, heures estimées, fréquence, message</li>
                  <li><strong>Formulaire de rendez-vous :</strong> nom, téléphone, email, service concerné, date préférée, créneau horaire, message</li>
                  <li><strong>Formulaire de contact :</strong> nom, téléphone, email, sujet, message</li>
                </ul>
                <p>Ces données sont collectées uniquement avec votre consentement explicite (case à cocher RGPD).</p>
              </div>
            </div>

            <div>
              <h2 className="font-['Space_Grotesk'] text-xl font-semibold mb-3">3. Finalités du traitement</h2>
              <div className="text-sm text-muted-foreground leading-relaxed space-y-2">
                <p>Vos données personnelles sont collectées pour les finalités suivantes :</p>
                <ul className="list-disc pl-5 space-y-1">
                  <li>Traitement de vos demandes de devis et de rendez-vous</li>
                  <li>Réponse à vos questions et messages</li>
                  <li>Gestion de la relation client</li>
                  <li>Amélioration de nos services</li>
                </ul>
                <p>Vos données ne sont jamais vendues à des tiers et ne sont utilisées qu'à des fins internes pour le bon fonctionnement de nos services.</p>
              </div>
            </div>

            <div>
              <h2 className="font-['Space_Grotesk'] text-xl font-semibold mb-3">4. Base légale du traitement</h2>
              <div className="text-sm text-muted-foreground leading-relaxed space-y-2">
                <p>Le traitement de vos données personnelles repose sur :</p>
                <ul className="list-disc pl-5 space-y-1">
                  <li><strong>Votre consentement</strong> (article 6.1.a du RGPD) : en cochant la case de consentement sur nos formulaires</li>
                  <li><strong>L'exécution d'un contrat</strong> (article 6.1.b du RGPD) : pour la réalisation des prestations de services</li>
                  <li><strong>L'intérêt légitime</strong> (article 6.1.f du RGPD) : pour l'amélioration de nos services</li>
                </ul>
              </div>
            </div>

            <div>
              <h2 className="font-['Space_Grotesk'] text-xl font-semibold mb-3">5. Durée de conservation</h2>
              <div className="text-sm text-muted-foreground leading-relaxed space-y-2">
                <p>Vos données personnelles sont conservées pendant une durée maximale de :</p>
                <ul className="list-disc pl-5 space-y-1">
                  <li><strong>Demandes de devis et rendez-vous :</strong> 3 ans à compter de votre dernière interaction</li>
                  <li><strong>Messages de contact :</strong> 1 an après la réponse apportée</li>
                  <li><strong>Données clients :</strong> durée de la relation contractuelle + 5 ans (obligation légale)</li>
                </ul>
              </div>
            </div>

            <div>
              <h2 className="font-['Space_Grotesk'] text-xl font-semibold mb-3">6. Vos droits</h2>
              <div className="text-sm text-muted-foreground leading-relaxed space-y-2">
                <p>Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés, vous disposez des droits suivants :</p>
                <ul className="list-disc pl-5 space-y-1">
                  <li><strong>Droit d'accès :</strong> obtenir la confirmation que vos données sont traitées et en obtenir une copie</li>
                  <li><strong>Droit de rectification :</strong> demander la correction de données inexactes ou incomplètes</li>
                  <li><strong>Droit à l'effacement :</strong> demander la suppression de vos données personnelles</li>
                  <li><strong>Droit à la limitation :</strong> demander la limitation du traitement de vos données</li>
                  <li><strong>Droit à la portabilité :</strong> recevoir vos données dans un format structuré</li>
                  <li><strong>Droit d'opposition :</strong> vous opposer au traitement de vos données</li>
                  <li><strong>Droit de retrait du consentement :</strong> retirer votre consentement à tout moment</li>
                </ul>
                <p className="mt-3">Pour exercer vos droits, contactez-nous par email à <a href={`mailto:${COMPANY_INFO.email}`} className="text-[hsl(var(--primary))] underline">{COMPANY_INFO.email}</a> ou par courrier à l'adresse : {COMPANY_INFO.address}, {COMPANY_INFO.city}.</p>
                <p>Vous disposez également du droit d'introduire une réclamation auprès de la CNIL (Commission Nationale de l'Informatique et des Libertés) : <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="text-[hsl(var(--primary))] underline">www.cnil.fr</a></p>
              </div>
            </div>

            <div>
              <h2 className="font-['Space_Grotesk'] text-xl font-semibold mb-3">7. Sécurité des données</h2>
              <div className="text-sm text-muted-foreground leading-relaxed">
                <p>Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données personnelles contre tout accès non autorisé, modification, divulgation ou destruction. L'accès aux données est strictement limité aux personnes habilitées dans le cadre de leurs fonctions.</p>
              </div>
            </div>

            <div>
              <h2 className="font-['Space_Grotesk'] text-xl font-semibold mb-3">8. Transfert de données</h2>
              <div className="text-sm text-muted-foreground leading-relaxed">
                <p>Vos données personnelles ne font l'objet d'aucun transfert en dehors de l'Union Européenne. Elles sont hébergées sur des serveurs sécurisés.</p>
              </div>
            </div>

            <div className="pt-4 border-t border-border">
              <p className="text-xs text-muted-foreground">Dernière mise à jour : Janvier 2025</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
